<template>
  <v-row class="pa-4">
    <p class="checkbox-label" data-qa="enabled-checkbox-label">{{ $t("enabled") }}</p>
      <v-checkbox density="compact" color="primary" false-icon="ecc:ecc-D-QuadOFF" true-icon="ecc:ecc-D-QuadON"
        hide-details v-model="action.enabled" data-qa="enabled-checkbox" />
  </v-row>
  <!-- From -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <v-text-field
        data-qa="trigger-action-email-from"
        v-model="action.emailConfig.emailFrom"
        :rules="emailRules"
        :label="$t('sender')"
        :disabled="isUpdating"
      />
    </v-col>
  </v-row>
  <!-- To -->
  <v-row class="my-0">
    <v-col cols="1" class="py-1 pr-0"> {{ $t("to") }}: </v-col>
    <v-col cols="11" class="py-1 pr-0">
      <v-card variant="flat" class="checkbox-list">
        <v-card-text class="py-0">
          <div class="checkbox-div">
            <VChipComponent
              data-qa="trigger-action-email-bcc"
              ref="toChips"
              property="name"
              type="alarm"
              :rules="emailRulesEmpty"
              :showEnterButton="true"
              :label="$t('addEmail')"
              :choosenItems="choosenTo"
              @removeItem="removeTo"
              @setItem="addTo"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <!-- Bcc -->
  <v-row class="my-0">
    <v-col cols="1" class="py-1 pr-0"> {{ $t("bcc") }}: </v-col>
    <v-col cols="11" class="py-1 pr-0">
      <v-card variant="flat" class="checkbox-list">
        <v-card-text class="py-0">
          <div class="checkbox-div">
            <VChipComponent
              data-qa="trigger-action-email-bcc"
              ref="bccChips"
              property="name"
              type="alarm"
              :rules="emailRulesEmpty"
              :showEnterButton="true"
              :label="$t('addEmail')"
              :choosenItems="choosenBcc"
              @removeItem="removeBcc"
              @setItem="addBcc"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <!-- subject -->
  <v-row class="my-2">
    <v-col class="py-1 pr-0">
      <div>Subject</div>
      <MustacheEditor
        owner="subject-mustache"
        v-model="action.emailConfig.subject"
        @update:value="updateSubject"
        :width="440"
        :height="60"
        dataQa="subject-mustache"
        refName="subject"
      ></MustacheEditor>
    </v-col>
  </v-row>
  <!-- body  -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <div>Body</div>
      <MustacheEditor
        owner="template-mustache"
        v-model="action.emailConfig.template"
        @update:value="updateTemplate"
        :width="440"
        :height="250"
        dataQa="template-mustache"
        refName="template"
      ></MustacheEditor>
    </v-col>
  </v-row>
  <!-- x-days -->
  <TriggerActionXdaysComponent class="pa-0" :config="action.emailConfig" />
</template>

<script lang="ts">
import MustacheEditor from '../UIComponents/MustacheEditor.vue';
import { defineComponent } from "vue";
import { TriggerEmailAction } from "./type.util";
import VChipComponent from "../UIComponents/VChipComponent.vue";
import AnimatedButton from "../UIComponents/AnimatedButton.vue";
import TriggerActionXdaysComponent from './TriggerActionXdaysComponent.vue';

export default defineComponent({
  name: "TriggerActionEmailComponent",
  components: {
    VChipComponent,
    AnimatedButton,
    MustacheEditor,
    TriggerActionXdaysComponent,
  },
  data() {
    return {
      emailRules: [
        //(v) => !!v || $t('fieldRules.emailIsRequired'),
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || this.$t("notValidEmail"),
      ],
      emailRulesEmpty: [
        (v) =>
          !v || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || this.$t("notValidEmail"),
      ],
      isUpdating: false,
      choosenBcc: [],
      choosenTo: [],
      activeTimePeriod: [false, false, false, false, false, false, false],
    };
  },
  props: {
    action: {
      type: Object as () => TriggerEmailAction,
      default: null,
    },
  },
  methods: {
    deleteActionConfirmation() {
      this.$emit("deleteActionConfirmation", this.action);
    },
    addBcc(event) {
      if (event.name == "") return;
      if (
        (this.$refs.bccChips as any).choosenItems.find(
          (o) => o.name == event.name
        )
      )
        return;
      (this.$refs.bccChips as any).choosenItems.push(event);
      //concat to string emailBcc
      this.action.emailConfig.emailBcc += event.name + ";";
    },
    removeBcc(event) {
      if ((this.$refs.bccChips as any).choosenItems.indexOf(event) == -1)
        return;
      (this.$refs.bccChips as any).choosenItems.splice(
        (this.$refs.bccChips as any).choosenItems.indexOf(event),
        1
      );
      //remove from string emailBcc
      this.action.emailConfig.emailBcc =
        this.action.emailConfig.emailBcc.replace(event.name + ";", "");
    },
    addTo(event) {
      if (event.name == "") return;
      if (
        (this.$refs.toChips as any).choosenItems.find(
          (o) => o.name == event.name
        )
      )
        return;
      (this.$refs.toChips as any).choosenItems.push(event);
      //concat to string emailBcc
      this.action.emailConfig.emailTo += event.name + ";";
    },
    removeTo(event) {
      if ((this.$refs.toChips as any).choosenItems.indexOf(event) == -1) return;
      (this.$refs.toChips as any).choosenItems.splice(
        (this.$refs.toChips as any).choosenItems.indexOf(event),
        1
      );
      //remove from string emailBcc
      this.action.emailConfig.emailTo = this.action.emailConfig.emailTo.replace(
        event.name + ";",
        ""
      );
    },
    computeBccChose() {
      if (this.action.emailConfig.emailBcc) {
        this.choosenBcc = this.action.emailConfig.emailBcc
          .split(";")
          .map((m) => {
            return {
              name: m,
            };
          });
        //remove last split
        this.choosenBcc.pop();
      }
    },
    computeToChose() {
      if (this.action.emailConfig.emailTo) {
        this.choosenTo = this.action.emailConfig.emailTo.split(";").map((m) => {
          return {
            name: m,
          };
        });
        //remove last split
        this.choosenTo.pop();
      }
    },
    computeXdays(): void {
      // this.activeTimePeriod = [false, false, false, false, false, false, false];
      for (let i = 0; i < 7; i++) {
        this.activeTimePeriod[i] =
          this.action.emailConfig.xdays.indexOf("" + i) > -1 ? true : false;
      }
    },
    initAction(): void {
      this.computeBccChose();
      this.computeToChose();
      this.computeXdays();
    },
    updateSubject(value){
      this.action.emailConfig.subject = value;
    },
    updateTemplate(value){
      this.action.emailConfig.template = value;
    },
  },
  watch: {
    action: function (action) {
      this.initAction();
    },
    activeTimePeriod: {
      handler: function (atp): void {
        const positions: number[] = [];
        for (let i = 0; i < this.activeTimePeriod.length; i++) {
          if (this.activeTimePeriod[i]) {
            positions.push(i);
          }
        }
        this.action.emailConfig.xdays = positions.join(", ");
      },
      deep: true,
    },
  },
  mounted() {
    this.initAction();
  },
});
</script>

<style scoped>
.header {
  font-weight: bold;
}
.no-border .v-input__slot {
  border: 0px;
}
.email-text-area.v-textarea >>> textarea {
  border: 1px solid var(--color-g4);
  padding: 20px 8px 2px 8px;
  margin-top: 10px;
  line-height: 1.1rem;
}

.min-span {
  min-width: 32px;
}
.checkbox-list {
  width: 100%;
}
.checkbox-label {
  line-height: 40px;
  width: 60px;
}
.max-100 {
  max-width: 100%;
}
.ellipsis-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}
.policy-header {
  color: var(--color-g4);
}
.ecc.v-chip .close {
  color: var(--color-dk) !important;
}
</style>
